var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.presidentialElectionsSecondRoundData.lastBulletin
    ? _c(
        "div",
        {
          staticClass: "presidential-elections-second-round",
          class: { container: !_vm.isElectionTag },
        },
        [
          _c("h3", { staticClass: "heading-title" }, [
            _vm._v("\n    Elecciones Presidenciales 2026 - Segunda Vuelta\n  "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "first-col" },
            [
              _vm._l(
                _vm.presidentialElectionsSecondRoundData.lastBulletin.candidates.slice(
                  0,
                  2
                ),
                function (item) {
                  return [
                    _c("div", { staticClass: "card-election-1" }, [
                      _c("img", {
                        attrs: {
                          alt: item.name,
                          title: item.name,
                          src: item.image + "?w=320",
                          height: 210,
                          width: 210,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-candidate" }, [
                        _c("div", {
                          staticClass: "candidate-name",
                          domProps: { innerHTML: _vm._s(item.name) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "votes" }, [
                          _vm._v("Votos " + _vm._s(_vm.format(item.votes))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bar" }, [
                          _c("div", {
                            staticClass: "r",
                            style: {
                              width: item.percentage * 100 + "%",
                              backgroundColor: item.color,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "percentage",
                          style: { color: item.color },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.formatPercent(item.percentage)
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", [_c("PresidentialElections2026Colgraph")], 1),
          _vm._v(" "),
          _c("div", { staticClass: "third-col bulletin-info-cards" }, [
            _c("div", { staticClass: "wrap-bulletin" }, [
              _c("div", { staticClass: "bulletin" }, [
                _vm._v("\n        AVANCE\n        "),
                _c("span", {
                  staticClass: "number-bulletin",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.presidentialElectionsSecondRoundData.lastBulletin
                        .bulletin.bulletinNumber
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "current-time",
                domProps: { innerHTML: _vm._s(_vm.currentTime) },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-info c-1" }, [
              _c("div", { staticClass: "row-1" }, [
                _c("div", { staticClass: "percentage" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatPercent(
                          _vm.presidentialElectionsSecondRoundData.lastBulletin
                            .bulletin.percentageInformedTables
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "informed-tables" }, [
                  _vm._v("Mesas Informadas"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsSecondRoundData.lastBulletin
                          .bulletin.informedTables
                      )
                    ) +
                    "\n        de\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsSecondRoundData.lastBulletin
                          .bulletin.totalTables
                      )
                    ) +
                    "\n        mesas informadas\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-info c-2" }, [
              _c("div", { staticClass: "row-1" }, [
                _c("div", { staticClass: "percentage" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatPercent(
                          _vm.presidentialElectionsSecondRoundData.lastBulletin
                            .bulletin.percentageTotalVotes
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vote" }, [_vm._v("Votación")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsSecondRoundData.lastBulletin
                          .bulletin.totalVotes
                      )
                    ) +
                    "\n        de\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsSecondRoundData.lastBulletin
                          .bulletin.potentialVotes
                      )
                    ) +
                    "\n        personas habilitadas\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-info" }, [
              _c("div", { staticClass: "row-1" }, [
                _c("div", { staticClass: "percentage" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatPercent(
                          _vm.presidentialElectionsSecondRoundData.lastBulletin
                            .bulletin.percentageBlankVotes
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vote" }, [_vm._v("En Blanco")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsSecondRoundData.lastBulletin
                          .bulletin.blankVotes
                      )
                    ) +
                    "\n        votos\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-info" }, [
              _c("div", { staticClass: "row-1" }, [
                _c("div", { staticClass: "percentage" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.formatPercent(
                          _vm.presidentialElectionsSecondRoundData.lastBulletin
                            .bulletin.percentageNullVotes
                        )
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vote" }, [_vm._v("Nulos")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.format(
                        _vm.presidentialElectionsSecondRoundData.lastBulletin
                          .bulletin.nullVotes
                      )
                    ) +
                    "\n        votos\n      "
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.presidentialElectionsUrl
            ? _c("div", { staticClass: "button" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    attrs: { href: _vm.presidentialElectionsUrl },
                  },
                  [_vm._v("RESULTADOS COMPLETOS")]
                ),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }